import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import Transition from '@/components/Common/Transition';
import WorkspaceSettingComplete from '@/features/CreateWorkspace/WorkspaceSettingComplete';
import useColor from '@/hooks/domain/useColor';

const CreateWorkspaceComplete = () => {
  const color = useColor();
  return (
    <Style>
      <Transition
        status={true}
        style={{
          backgroundColor: color.gray100,
          borderRadius: 8,
          width: 648,
        }}
      >
        <WorkspaceSettingComplete />
      </Transition>
    </Style>
  );
};

const Style = styled(CenterFlex)`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray200};
`;

export default CreateWorkspaceComplete;
